module.exports = __webpack_public_path__ + "static/media/login-background-image.0049d7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-background-image.jpg
// module id = 685
// module chunks = 0